import React from 'react';
import { Card, Descriptions } from 'antd';
import PropTypes from 'prop-types';
import { FileList } from 'components/layout';
import DateDisplay from '../../../../layout/DateDisplay';
import { formatEnum } from '../../../../../utils';

const WithdrawalDetail = ({ data, title, confirm }) => {
  const withdrawal = data.withdrawals[0];

  return (
    <Card title={title}>
      <Descriptions>
        {!confirm && (
          <>
            <Descriptions.Item label="Withdrawal Request Date" span={1}>
              <DateDisplay date={withdrawal.date} />
            </Descriptions.Item>
            <Descriptions.Item label="Status" span={2}>
              {formatEnum(withdrawal.status)}
            </Descriptions.Item>
          </>
        )}

        <Descriptions.Item label="Progress Report" span={3}>
          <FileList files={[withdrawal?.progressReport]} />
        </Descriptions.Item>
        <Descriptions.Item label="Justification" span={3}>
          {withdrawal.justification}
        </Descriptions.Item>
      </Descriptions>
    </Card>
  );
};

WithdrawalDetail.defaultProps = {
  data: {
    withdrawals: [],
  },
  title: 'Withdrawal Detail',
  confirm: false,
};

WithdrawalDetail.propTypes = {
  data: PropTypes.object.isRequired,
  title: PropTypes.string.isRequired,
  confirm: PropTypes.bool.isRequired,
};

export default WithdrawalDetail;
